import { useLocation, useNavigate } from 'react-router';

import IconBack from '@/assets/svg/icon-back.svg?react';

import { useGlobalStore } from '@/stores/globalStore';

import { executorRoutes } from '@/constants/route-settings';

export const BackButton = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { navigationSource, setNavigationSource } = useGlobalStore();

  const isDocumentPage = location.pathname.includes(executorRoutes.myDocuments);
  const isSearchResultPage = location.pathname.includes(
    executorRoutes.fileSearchResult,
  );

  // Determine if back button should be shown
  const shouldShowBackButton =
    (isDocumentPage && navigationSource !== null) || isSearchResultPage;

  if (!shouldShowBackButton) {
    return null;
  }

  const handleBack = () => {
    if (isSearchResultPage) {
      // From search results, always go back to search page
      navigate(executorRoutes.search);
    } else if (isDocumentPage && navigationSource === 'searchResults') {
      // From document page, go back to search results
      navigate(executorRoutes.fileSearchResult);
    } else if (isDocumentPage && navigationSource === 'myDocuments') {
      // From document page, go back to my documents root
      navigate(executorRoutes.myDocuments);
    }

    // Clear navigation source after navigating back
    setNavigationSource(null);
  };

  return (
    <button
      onClick={handleBack}
      className="mr-3 flex items-center justify-center"
      aria-label="Назад"
    >
      <IconBack className="h-7 w-7" />
    </button>
  );
};
